import { render } from "./BaseCreationPage.vue?vue&type=template&id=d3cdc16c"
import script from "./BaseCreationPage.vue?vue&type=script&lang=js"
export * from "./BaseCreationPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__